// Mock data for Gabriela Mendoza Thibeau Immigration Law Firm

export const firmInfo = {
  name: "Gabriela Mendoza Thibeau",
  tagline: "Your Trusted Partner in Immigration Law",
  description: "With years of experience navigating complex immigration cases, we provide compassionate, expert legal representation to help you achieve your American dream.",
  phone: "(513) 759-0377",
  email: "gabrielamendozathibeau@yahoo.com",
  address: "9078 Union Centre Blvd., Suite 350, West Chester, OH 45069",
  hours: "By Appointment Only - Available before/after business hours and weekends if necessary"
};

export const services = [
  {
    id: 1,
    title: "Family-Based Immigration",
    icon: "Users",
    description: "Reunite with your loved ones. We handle family visa petitions, green card applications, and help bring your family members to the United States.",
    image: "https://images.unsplash.com/photo-1762034498736-7067e4e61735",
    details: [
      "Immediate Relative Petitions",
      "Family Preference Categories",
      "K-1 Fiancé(e) Visas",
      "Adjustment of Status"
    ]
  },
  {
    id: 2,
    title: "Citizenship & Naturalization",
    icon: "Award",
    description: "Become a U.S. citizen and enjoy all the rights and privileges. We guide you through every step of the naturalization process.",
    image: "https://images.unsplash.com/photo-1764040821682-016e0ce606cb",
    details: [
      "Naturalization Applications",
      "Citizenship Interview Preparation",
      "Certificate of Citizenship",
      "Derivative Citizenship"
    ]
  },
  {
    id: 3,
    title: "DACA (Deferred Action)",
    icon: "Shield",
    description: "Protect your status in the United States. Expert assistance with DACA initial applications, renewals, and related immigration matters.",
    image: "https://images.unsplash.com/photo-1717849467326-cea1b28d9d2b",
    details: [
      "Initial DACA Applications",
      "DACA Renewals",
      "Work Permit Applications",
      "Travel Authorization"
    ]
  },
  {
    id: 4,
    title: "Waivers",
    icon: "FileText",
    description: "Overcome inadmissibility issues. We specialize in obtaining waivers for various grounds of inadmissibility.",
    image: "https://images.unsplash.com/photo-1492217072584-7ff26c10eb75",
    details: [
      "I-601 Waivers",
      "I-601A Provisional Waivers",
      "Fraud & Misrepresentation Waivers",
      "Criminal Ground Waivers"
    ]
  },
  {
    id: 5,
    title: "Consular Processing",
    icon: "Globe",
    description: "Navigate the visa application process abroad. Expert guidance through consular interviews and immigrant visa processing.",
    image: "https://images.unsplash.com/photo-1619418602850-35ad20aa1700",
    details: [
      "NVC Case Processing",
      "Consular Interview Preparation",
      "Document Collection & Review",
      "Post-Interview Support"
    ]
  },
  {
    id: 6,
    title: "Re-Entry Permits",
    icon: "KeyRound",
    description: "Maintain your permanent resident status while traveling abroad. We help you obtain re-entry permits for extended international travel.",
    image: "https://images.unsplash.com/photo-1468779036391-52341f60b55d",
    details: [
      "Form I-131 Applications",
      "Biometrics Appointment Assistance",
      "Extended Travel Authorization",
      "Green Card Protection"
    ]
  },
  {
    id: 7,
    title: "Travel Documents / Advance Parole",
    icon: "Plane",
    description: "Secure authorization to travel internationally and return to the U.S. while your immigration application is pending.",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05",
    details: [
      "Advance Parole Applications",
      "Emergency Travel Documents",
      "Refugee Travel Documents",
      "Travel Authorization Processing"
    ]
  },
  {
    id: 8,
    title: "EAD Employment Documents",
    icon: "Briefcase",
    description: "Obtain work authorization in the United States. We handle Employment Authorization Document applications and renewals.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    details: [
      "EAD Initial Applications",
      "EAD Renewals",
      "Combo Card Processing",
      "Work Permit Expediting"
    ]
  },
  {
    id: 9,
    title: "U-Visa Adjustment of Status",
    icon: "ShieldCheck",
    description: "Transition from U visa holder to lawful permanent resident. Expert guidance through the adjustment of status process for crime victims.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f",
    details: [
      "Form I-485 Filing",
      "Three-Year Continuous Presence",
      "Humanitarian Grounds Assessment",
      "Green Card Application Support"
    ]
  }
];

export const aboutContent = {
  title: "About Gabriela Mendoza Thibeau",
  mainText: "With over 25 years of dedicated service in immigration law, Gabriela Mendoza Thibeau has helped hundreds of families achieve their dreams of living and working in the United States. Our firm is built on a foundation of compassion, expertise, and unwavering commitment to our clients.",
  mission: "Our mission is to provide exceptional legal representation while treating every client with the dignity and respect they deserve. We understand that immigration is not just about paperwork—it's about people, families, and futures.",
  image: "/gabriela-photo.jpg",
  stats: [
    { number: "500+", label: "Cases Successfully Resolved" },
    { number: "25+", label: "Years of Experience" },
    { number: "98%", label: "Client Satisfaction Rate" },
    { number: "24/7", label: "Client Support" }
  ],
  values: [
    {
      title: "Expertise",
      description: "Deep knowledge of immigration law and procedures"
    },
    {
      title: "Compassion",
      description: "Understanding the human side of every case"
    },
    {
      title: "Integrity",
      description: "Honest, transparent communication throughout"
    },
    {
      title: "Results",
      description: "Dedicated to achieving the best possible outcomes"
    }
  ]
};

export const testimonials = [];

export const resources = [
  {
    id: 1,
    category: "Guide",
    title: "Understanding the Green Card Process",
    description: "A comprehensive guide to obtaining permanent residence in the United States, including eligibility requirements and timeline expectations.",
    date: "December 2024"
  },
  {
    id: 2,
    category: "News",
    title: "Recent Changes to Immigration Policy",
    description: "Stay informed about the latest updates to U.S. immigration law and how they may affect your case.",
    date: "December 2024"
  },
  {
    id: 3,
    category: "FAQ",
    title: "Common Questions About Naturalization",
    description: "Answers to frequently asked questions about becoming a U.S. citizen, including requirements and the application process.",
    date: "November 2024"
  },
  {
    id: 4,
    category: "Guide",
    title: "Preparing for Your Consular Interview",
    description: "Essential tips and document checklists to help you successfully navigate your immigrant visa interview abroad.",
    date: "November 2024"
  },
  {
    id: 5,
    category: "News",
    title: "DACA Updates and What They Mean for You",
    description: "Important information about recent DACA policy changes and how to maintain your protected status.",
    date: "October 2024"
  },
  {
    id: 6,
    category: "FAQ",
    title: "Waiver Options for Inadmissibility",
    description: "Understanding when and how to apply for waivers if you have grounds of inadmissibility.",
    date: "October 2024"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the immigration process typically take?",
    answer: "Processing times vary significantly depending on the type of case, current USCIS workload, and individual circumstances. Family-based petitions can range from several months to several years. During your consultation, we'll provide a realistic timeline for your specific situation."
  },
  {
    id: 2,
    question: "What documents do I need for my immigration case?",
    answer: "Required documents vary by case type, but commonly include birth certificates, marriage certificates, passport copies, financial documents, and police clearances. We provide a comprehensive checklist tailored to your specific case during our initial consultation."
  },
  {
    id: 3,
    question: "How much do your legal services cost?",
    answer: "Our fees depend on the complexity of your case. We offer transparent pricing and will provide a detailed fee agreement during your consultation. We also offer flexible payment plans to make our services accessible."
  },
  {
    id: 4,
    question: "Can you help if my visa application was denied?",
    answer: "Yes, we have extensive experience with appeals and motions to reopen or reconsider denied applications. We'll review your case, identify the reasons for denial, and develop a strategy to move forward."
  },
  {
    id: 5,
    question: "Do you offer consultations in languages other than English?",
    answer: "Yes, we are fluent in Spanish and English. We understand the importance of clear communication in your native language when discussing complex legal matters."
  }
];
